import { useParams } from "react-router-dom";

/**
 * Restaurant slug from the current route's `:slug` param only (no env fallback).
 */
export function usePublicTenantSlug(): string {
  const { slug } = useParams<{ slug?: string }>();

  const value = slug?.trim() ?? "";

  return value;
}
